import { render, staticRenderFns } from "./BtnInserirAtualizarItemContrato.vue?vue&type=template&id=c7bcffb0&"
import script from "./BtnInserirAtualizarItemContrato.vue?vue&type=script&lang=js&"
export * from "./BtnInserirAtualizarItemContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports